var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColleague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_colleague",
    d: "M2-3.5a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1-2-3.5V-5H-8V-.5A1.538,1.538,0,0,0-6.5,1h13A1.538,1.538,0,0,0,8-.5V-5H2ZM6.5-11H4v-1.5A1.538,1.538,0,0,0,2.5-14h-5A1.538,1.538,0,0,0-4-12.5V-11H-6.5A1.538,1.538,0,0,0-8-9.5V-6H8V-9.5A1.538,1.538,0,0,0,6.5-11Zm-4,0h-5v-1.5h5Z",
    transform: "translate(8 14)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColleague);
export default __webpack_public_path__ + "static/media/colleague.c7e2a1686afb56837f7e839f4184119e.svg";
export { ForwardRef as ReactComponent };